import "../assets/index-1f25a3c0.css";
import { n as s } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const n = {
  name: "NcAppSettingsSection",
  inject: ["registerSection", "unregisterSection"],
  props: {
    name: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0,
      validator(e) {
        return /^[a-z0-9\-_]+$/.test(e);
      }
    }
  },
  computed: {
    // generate an id for each settingssection based on the name without whitespaces
    htmlId() {
      return "settings-section_" + this.id;
    }
  },
  // Reactive changes for section navigation
  watch: {
    id(e, t) {
      var i;
      this.unregisterSection(t), this.registerSection(e, this.name, (i = this.$slots) == null ? void 0 : i.icon);
    },
    name(e) {
      var t;
      this.unregisterSection(this.id), this.registerSection(this.id, e, (t = this.$slots) == null ? void 0 : t.icon);
    }
  },
  mounted() {
    var e;
    this.registerSection(this.id, this.name, (e = this.$slots) == null ? void 0 : e.icon);
  },
  beforeDestroy() {
    this.unregisterSection(this.id);
  }
};
var r = function() {
  var t = this, i = t._self._c;
  return i("div", { staticClass: "app-settings-section", attrs: { id: t.htmlId } }, [i("h3", { staticClass: "app-settings-section__name" }, [t._v(" " + t._s(t.name) + " ")]), t._t("default"), t._e()], 2);
}, o = [], c = /* @__PURE__ */ s(
  n,
  r,
  o,
  !1,
  null,
  "5162e6df",
  null,
  null
);
const d = c.exports;
export {
  d as default
};
